import React from 'react';
import { DefaultFlexStrechedWrapper } from 'src/components/ui/odfjellPanel/OdfjellPanel.styles';
import { ReportOptionDescriptionText, ReportOptionIconWrapper, ReportOptionWrapper } from '../PageHeaderStowage.style';
import { OptionOpacityWrapper } from './reportPanel.style';

interface IncludeFillRatioSelectorProps {
    includeFillRatio: boolean;
    setIncludeFillRatio: (includeFillRatio: boolean) => void;
    disabled?: boolean;
}

const IncludeFillRatioSelector: React.FC<IncludeFillRatioSelectorProps> = ({ includeFillRatio, setIncludeFillRatio, disabled }) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIncludeFillRatio(event.target.checked);
    };

    return (
        <ReportOptionWrapper onClick={() => !disabled && setIncludeFillRatio(!includeFillRatio)} disabled={disabled}>
            <OptionOpacityWrapper disabled={disabled}>
                <DefaultFlexStrechedWrapper noMargin>
                    <ReportOptionIconWrapper>
                        <input
                            type="checkbox"
                            checked={includeFillRatio}
                            onChange={handleChange}
                            onClick={(e) => e.stopPropagation()}
                            aria-label="Include fill ratio"
                            disabled={disabled}
                            style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
                        />
                    </ReportOptionIconWrapper>
                    <ReportOptionDescriptionText>Include fill ratio</ReportOptionDescriptionText>
                </DefaultFlexStrechedWrapper>
            </OptionOpacityWrapper>
        </ReportOptionWrapper>
    );
};

export default IncludeFillRatioSelector;
